/* BKS — Gardien de panier pour les selles configurées (2D / FUSION).
   Lie la selle personnalisée à ses options (suppléments) via la propriété cachée _bks_id.
   Si le client retire une ligne (ou casse le compte / la quantité), TOUTE la selle est retirée.
   NOUVEAU : validation AU CLIC sur "Passer la commande" (bloque la course où le client
   retire l'option puis paie avant que le gardien réactif n'ait agi). */
(function(){
  if(window.__bksCartGuard) return; window.__bksCartGuard=1;
  var BUSY=false, TMR=null;
  var MSG="Une option payante a été retirée : ta selle personnalisée ne peut pas être commandée sans ses options. Elle a été enlevée du panier — reconfigure-la si besoin.";

  /* analyse le panier -> { updates, changed, removed } (removed = un bundle a été cassé) */
  function analyze(cart){
    var groups={};
    (cart.items||[]).forEach(function(it){
      var p=it.properties||{}; var id=p._bks_id; if(!id) return;
      if(!groups[id]) groups[id]={base:null,supps:[],parts:0};
      if(p._bks_role==='base'){ groups[id].base=it; groups[id].parts=parseInt(p._bks_parts||'0',10)||0; }
      else groups[id].supps.push(it);
    });
    var updates={}, changed=false, removed=false;
    Object.keys(groups).forEach(function(id){
      var g=groups[id]; var present=(g.base?1:0)+g.supps.length;
      // brique de prix (FUSION "Options x N") : sa quantité DOIT valoir base.quantité x _bks_brickqty.
      var bq = g.base ? (parseInt((g.base.properties||{})._bks_brickqty||'0',10)||0) : 0;
      var tamper=false, brickPresent=false;
      if(g.base){ g.supps.forEach(function(s){ if(((s.properties||{})._bks_role)==='brick'){ brickPresent=true; if(bq && s.quantity!==g.base.quantity*bq) tamper=true; } }); }
      // brique attendue (bq>0) mais absente = fraude (client a retiré la ligne Options)
      if(bq && !brickPresent) tamper=true;
      if(!g.base || (g.parts && present!==g.parts) || tamper){
        if(g.base) updates[g.base.key]=0;
        g.supps.forEach(function(s){ updates[s.key]=0; });
        changed=true; removed=true;
      } else if(g.base){
        var q=g.base.quantity;
        g.supps.forEach(function(s){
          if(((s.properties||{})._bks_role)==='brick') return; // brique vérifiée ci-dessus
          if(s.quantity!==q){ updates[s.key]=q; changed=true; }
        });
      }
    });
    return { updates:updates, changed:changed, removed:removed };
  }

  function getCart(){ return fetch('/cart.js',{cache:'no-cache',headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function applyUpdates(u){ return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:u})}); }

  /* gardien réactif : après une modif de panier, corrige/retire et recharge */
  function schedule(){ if(TMR) clearTimeout(TMR); TMR=setTimeout(run, 250); }
  function run(){
    if(BUSY) return;
    getCart().then(function(cart){
      var res=analyze(cart);
      if(!res.changed) return;
      BUSY=true;
      applyUpdates(res.updates).then(function(){
        if(res.removed){ try{ alert(MSG); }catch(e){} }
        window.location.reload();
      }).catch(function(){ BUSY=false; });
    }).catch(function(){});
  }

  /* ---- protection AU MOMENT DU PAIEMENT (ferme la course) ---- */
  var CHECKING=false;
  function guardCheckout(e){
    if(CHECKING) return;                 // déjà validé -> laisser passer
    e.preventDefault(); e.stopImmediatePropagation();
    CHECKING=true;
    getCart().then(function(cart){
      var res=analyze(cart);
      if(res.removed){                    // bundle cassé -> on bloque et on nettoie
        applyUpdates(res.updates).then(function(){ try{ alert(MSG); }catch(e){} window.location.reload(); })
          .catch(function(){ CHECKING=false; });
      } else {                            // panier OK -> on va au paiement
        if(res.changed){ applyUpdates(res.updates).then(function(){ window.location.href='/checkout'; }); }
        else window.location.href='/checkout';
      }
    }).catch(function(){ window.location.href='/checkout'; }); // erreur réseau : ne pas bloquer une vente légitime
  }
  document.addEventListener('click', function(e){
    var b=e.target && e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if(b) guardCheckout(e);
  }, true);
  document.addEventListener('submit', function(e){
    if(e.submitter && e.submitter.name==='checkout') guardCheckout(e);
  }, true);

  /* masque les boutons de paiement express (Shop Pay/PayPal/GPay) quand un bundle est présent
     -> ils court-circuiteraient la validation ci-dessus */
  function hideExpressIfBundle(){
    getCart().then(function(cart){
      var hasBundle=(cart.items||[]).some(function(it){ return (it.properties||{})._bks_role==='base'; });
      if(!hasBundle) return;
      document.querySelectorAll('[class*=dynamic-checkout], shopify-accelerated-checkout, .shopify-payment-button, [class*=accelerated-checkout]').forEach(function(el){ el.style.display='none'; });
    }).catch(function(){});
  }

  /* ---- interception des modifs de panier (fetch + XHR) ---- */
  function watch(u){ return typeof u==='string' && /\/cart\/(change|update|add|clear)/.test(u); }
  var of=window.fetch;
  if(of){ window.fetch=function(){ var a=arguments; var u=(a[0]&&a[0].url)||a[0]||''; var pr=of.apply(this,a);
    try{ if(watch(u)){ pr.then(function(){ schedule(); hideExpressIfBundle(); }).catch(function(){}); } }catch(e){}
    return pr; }; }
  var ox=window.XMLHttpRequest;
  if(ox){ var oo=ox.prototype.open; ox.prototype.open=function(m,u){ this.__bksU=u; return oo.apply(this,arguments); };
    var os=ox.prototype.send; ox.prototype.send=function(){ var self=this;
      try{ if(watch(self.__bksU)){ self.addEventListener('load',function(){ schedule(); hideExpressIfBundle(); }); } }catch(e){}
      return os.apply(this,arguments); }; }

  function init(){ run(); hideExpressIfBundle(); }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
